import { render } from "./SirketBilgileri.vue?vue&type=template&id=0cf2d4a0&scoped=true"
import script from "./SirketBilgileri.vue?vue&type=script&lang=js"
export * from "./SirketBilgileri.vue?vue&type=script&lang=js"

import "./SirketBilgileri.vue?vue&type=style&index=0&id=0cf2d4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf2d4a0"]])

export default __exports__